module.exports = __webpack_public_path__ + "static/media/page_filled.7b361296.svg";